import { Typography } from '@mui/material'
import { TextParser } from '@weblite/web-textparser'
import { EmbeddedLink } from '@weblite/ts-action/message'
import { hyperLinkViewer } from '$common/hyperLink-viewer'
import { EMOJI_SPRITE_SHEET } from '$helper/constants/emoji'
import { linkParser } from '$common/link-parser'

// TODO: make link clickable
const parsers = [
  { name: 'emoji', args: { spritesheeturl: EMOJI_SPRITE_SHEET } },
  'code',
  { name: 'hyperLink', fn: hyperLinkViewer },
  { name: 'customLink', fn: linkParser },
]

interface Props {
  description: string
  links?: EmbeddedLink[]
}

export function MediaViewerCaption({ description, links = [] }: Props) {
  return (
    <Typography
      color="white"
      variant="body2"
      sx={{
        '--emoji-size': '18px',
        padding: '17px',
        maxHeight: '150px',
        overflowY: 'auto',
        scrollbarWidth: 'none',

        overflowWrap: 'break-word',
        wordWrap: 'break-word',
        wordBreak: 'break-word',
        whiteSpace: 'pre-wrap',
        textAlign: 'initial',

        '&::-webkit-scrollbar': {
          display: 'none',
        },
      }}
    >
      <TextParser
        parsers={parsers}
        text={description}
        links={links.map(({ url }) => url)}
      />
    </Typography>
  )
}
